/**
 * @generated SignedSource<<7d355e8fc2b5448aa4c34090e5d49bd2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TabsSettingsToggleFellowTabMutation$variables = {
  enable: boolean;
  streamId: string;
  tabId: string;
};
export type TabsSettingsToggleFellowTabMutation$data = {
  readonly StreamTab_ToggleFellowTab: {
    readonly stream: {
      readonly id: string;
      readonly isMeetingFeedbackTabEnabled: boolean;
      readonly tabs: ReadonlyArray<{
        readonly icon: string | null;
        readonly id: string;
        readonly isEmbedded: boolean;
        readonly order: number;
        readonly otherStreamId: string | null;
        readonly title: string;
        readonly url: string | null;
      }>;
    };
  } | null;
};
export type TabsSettingsToggleFellowTabMutation = {
  response: TabsSettingsToggleFellowTabMutation$data;
  variables: TabsSettingsToggleFellowTabMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enable"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "streamId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tabId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "enable",
        "variableName": "enable"
      },
      {
        "kind": "Variable",
        "name": "streamId",
        "variableName": "streamId"
      },
      {
        "kind": "Variable",
        "name": "tabId",
        "variableName": "tabId"
      }
    ],
    "concreteType": "ToggleFellowTab",
    "kind": "LinkedField",
    "name": "StreamTab_ToggleFellowTab",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "stream",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMeetingFeedbackTabEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStreamTabNode",
            "kind": "LinkedField",
            "name": "tabs",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "otherStreamId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "order",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isEmbedded",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TabsSettingsToggleFellowTabMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "TabsSettingsToggleFellowTabMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "14d1733680e381f66758bbac936696cc",
    "id": null,
    "metadata": {},
    "name": "TabsSettingsToggleFellowTabMutation",
    "operationKind": "mutation",
    "text": "mutation TabsSettingsToggleFellowTabMutation(\n  $enable: Boolean!\n  $tabId: String!\n  $streamId: ID!\n) {\n  StreamTab_ToggleFellowTab(enable: $enable, tabId: $tabId, streamId: $streamId) {\n    stream {\n      id\n      isMeetingFeedbackTabEnabled\n      tabs {\n        id\n        otherStreamId\n        icon\n        title\n        order\n        isEmbedded\n        url\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e5756f7030354fea16713bd794a6ded6";

export default node;
